// API Configuration
export const API_CONFIG = {
  // Main API for image description
  IMAGE_API_URL: 'https://api.describeapi.com',
  
  // Dashboard API for user management, tokens, etc.
  DASHBOARD_API_URL: 'https://dashboard.describeapi.com',
};

export default API_CONFIG;
